import React from 'react'

import { Collection, Group } from '../../components/details/collection'

import LocationCard from '../locations/location-card'
import { CollectionButton } from '../buttons'
import { connect } from 'react-redux'
import Unavailable from '../unavailable'
import get from 'lodash/get'

class LocationList extends React.Component {

  loadMoreButton () {
    if (this.props.hasNextPage) {
      return <CollectionButton onClick={this.props.onLoadNextPage}>See more...</CollectionButton>
    }
  }

  render () {
    const disabledFields = this.props.userType === 'Supervisor'
    if (disabledFields) {
      return (<Unavailable />)
    }

    return (
      <div className='list'>
        <div className='form-group list-search collection-search'>
          <input type='search' onChange={(event) => {
            this.props.onSearchLocations(event.target.value)
            return event
          }} placeholder='Filter by Location...' className='form-control form-control-lg' />
        </div>
        <Collection constraints={{ width: '595px' }}>
          <Group title='Locations'>
            {this.props.locations.map(location => (
              <LocationCard location={location} key={location.id} linkUrlBase={this.props.location.pathname}>
              </LocationCard>
            ))}
          </Group>
        </Collection>

        {this.loadMoreButton()}
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const userType = get(state.auth, 'session.type')

  return {
    userType
  }
}

export default connect(mapStateToProps)(LocationList)



// WEBPACK FOOTER //
// ./src/components/inspections/location-list.js